import React from 'react';
import { IconType } from 'react-icons';

interface IconProps {
  icon: IconType;
  className?: string;
  size?: string | number;
  color?: string;
}

/**
 * Wrapper per react-icons compatibile con React 19.
 * Risolve il conflitto TS2786 tra IconType e JSX.Element.
 */
const Icon: React.FC<IconProps> = ({ icon, className, size, color }) => {
  return React.createElement(icon as React.ComponentType<any>, {
    className,
    size,
    color,
  });
};

export default Icon;

